import { createAction, createReducer } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

export const ACTIVE_TENANT_STORAGE_KEY = "vision.activeTenantId";

export interface ActiveTenantState {
  tenantId: string | null;
}

const initialState: ActiveTenantState = {
  tenantId: null,
};

export const setActiveTenant = createAction<string | null>("activeTenant/set");

export function rememberActiveTenant(tenantId: string | null) {
  if (tenantId) {
    localStorage.setItem(ACTIVE_TENANT_STORAGE_KEY, tenantId);
  } else {
    localStorage.removeItem(ACTIVE_TENANT_STORAGE_KEY);
  }
}

export function readRememberedActiveTenant(): string | null {
  return localStorage.getItem(ACTIVE_TENANT_STORAGE_KEY);
}

export const selectActiveTenantId = (state: RootState) => state.activeTenant.tenantId;

export default createReducer(initialState, (builder) => {
  builder.addCase(setActiveTenant, (state, action) => {
    state.tenantId = action.payload;
  });
});
